import React, { Component } from 'react';
import EtelAPI from '../../../../api/EtelAPI';
import Alerts from '../../../../prototypes/Alerts';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';


let getMonthlyStatContainerStyle = ( ) => ( {
  'userSelect':'none',
  'borderTop':'solid 1pt #CFCFCF',
  'borderLeft':'solid 1pt #CFCFCF',
  'borderRight':'solid 1pt #CFCFCF',
  'borderBottom':'solid 1pt #CFCFCF',
  'width':'350px',
  'height':'225px',
  'borderRadius': '5px',
  'WebkitBoxShadow': '1px 1px 4px 1px rgba(204,204,204,0.75)',
  'MozBoxShadow': '1px 1px 4px 1px rgba(204,204,204,0.75)',
  'boxShadow': '1px 1px 4px 1px rgba(204,204,204,0.75)'
} );

let getMonthlyStatHeaderStyle = ( ) => ( {
  'display':'flex',
  'flexFlow':'row nowrap',
  'alignItems':'center',
  'justifyContent':'center',
  'fontWeight':'bold',
  'borderBottom':'solid 1pt #CFCFCF',
  'padding':'5px',
  'width': '100%'
} );

let getMonthlyStatBodyStyle = ( hasData ) => ( {
  'display':'flex',
  'alignItems': hasData === true ? 'flex-start' : 'center',
  'justifyContent': hasData === true ? 'flex-start' : 'center',
  'flexFlow':'column wrap',
  'height':'100%',
  'width': '100%',
  'overflow':'auto',
  'color': '#CFCFCF',
  'fontSize':'12pt'
} );

let getRowStyle = ( ) => ( {
  'padding': '10px',
  'display':'flex',
  'flexFlow': 'row wrap',
  'width': '100%',
  'height':'10px',
} );

let getLabelStyle = ( ) => ( {
  'padding': '10px',
  'color':'black',
  'paddingLeft':'10px',
  'fontSize':'10pt',
  'textAlign':'right',
  'fontWeight':'bold',
  'display':'flex',
  'flex': '0.85',
  'alignItems':'center',
  'justifyContent':'flex-start',
  'height':'100%',
} );

let getValueStyle = ( ) => ( {
  'padding': '10px',
  'color':'black',
  'paddingLeft':'10px',
  'fontSize':'10pt',
  'display':'flex',
  'flex': '0.15',
  'alignItems':'center',
  'justifyContent':'flex-end',
  'height':'100%',
} );

class MonthlyStatsTile extends Component {

  constructor( props ) {
    super( props );
    this.state = {
      title: props.title === undefined ? 'No Title' : props.title,
      clientID: props.clientID === undefined ? -1 : props.clientID,
      refreshDate: props.refreshDate === undefined ? '' : props.refreshDate,
      data: []
    };
  }

  componentDidMount() {
    this.getMonthlyStats( this.state.clientID ).then( ( data ) => {
      this.setState( {
        data: data
      } );
    } ).catch( ( exception ) => {
      this.setState( {
        data: []
      } );
      this.resolveErrors( exception );
    } );
  }

  compareProps( currentProps, nextProps ) {
    if( ( currentProps.refreshDate === nextProps.refreshDate ) &&
        ( currentProps.clientID === nextProps.clientID )
    ) {
      return false;
    } else { 
      return true; 
    }
  }

  componentWillReceiveProps( nextProps ) {
    if( this.compareProps( this.props, nextProps ) === true ) {
      this.getMonthlyStats( nextProps.clientID ).then( ( data ) => {
        this.setState( {
          title: nextProps.title === undefined ? 'No Title' : nextProps.title,
          clientID: nextProps.clientID === undefined ? -1 : nextProps.clientID,
          refreshDate: nextProps.refreshDate === undefined ? '' : nextProps.refreshDate,
          data: data
        } );
      } ).catch( ( exception ) => {
        this.resolveErrors( exception );
      } );
    }
  }

  doLogOff( ) {
    const { dispatch } = this.props;
    const auth = this.props.auth;
    const history = this.props.history;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  resolveErrors( e ) {
    const title = 'Wholesale Dashboard';
    const { bugsnag, dispatch } = this.props;
    const alerts = new Alerts( bugsnag,dispatch );
    const status = e.status === undefined ? 0 : e.status;
    if( status === 401 ) {
      alerts.INFO( title, 'Your session has expired.' , 5000 );
      this.doLogOff();
    } else if ( status === 503 ) {
      alerts.CRITICAL( title, 'The API server is unreachable for this request. Please retry request at a later time. If the problem persists please submit a help desk ticket.' );
    } else if( status === 500 ) {
      alerts.INFO( title, e.statusText , 5000 );
    } else if( status === 400 ) {
      alerts.WARNING( title, 'Request timed out.', 5000 );
    } else {
      alerts.CRITICAL( title, e );
    }  
  }

  getMonthlyStats( clientID ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'wholesale/dashboard' );
      api.uri = '/wholesale/dashboard/' + clientID.toString() + '/metric/monthly/stats';
      api.get().then( ( result ) => {
        resolve( result );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  getMonthlyStatsData( ) {
    const rows = this.state.data;
    if( rows !== undefined ) {
      if( rows.length > 0 ) {
        let monthlystatsrows = rows.map( ( row, index ) => {
          const items = row.METRIC.split( ':' );
          const monthlystat = {
            'label': items[ 0 ],
            'value': items[ 1 ]
          };
          return monthlystat;
        } );
        return monthlystatsrows;
      }
    }
    return [];
  }

  onRenderData( ) {
    const rows = this.getMonthlyStatsData();
    if( rows !== undefined ) {
      if( rows.length > 0 ) {
        let items = rows.map( ( row, index ) => {
          const itemkey = 'monthly-stat-item-' + index.toString();
          return (
            <div key={itemkey} style={getRowStyle()}>
              <span style={getLabelStyle()}>{row.label}:</span>
              <span style={getValueStyle()}>{row.value}</span>
            </div>
          );
        } );
        return items;
      }
    }
    return ( <span>No Data</span> );
  }

  render( ) {
    let hasData = false;
    const rows = this.state.data;
    if( rows !== undefined ) {
      if( rows.length > 0 ) {
        hasData = true;
      }
    }
    return (
      <div style={getMonthlyStatContainerStyle()} >
        <div style={getMonthlyStatHeaderStyle()}>
          {this.state.title}
        </div>
        <div style={getMonthlyStatBodyStyle( hasData )}>
          {this.onRenderData()}
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect (
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( MonthlyStatsTile ) );




// WEBPACK FOOTER //
// ./src/content/wholesale/dashboard/components/MonthlyStatsTile.js